module.exports = __webpack_public_path__ + "static/media/hp1.4bd19d11.gif";